function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  transform: "translate(890 -1538.14)"
}, React.createElement("g", {
  transform: "translate(-890 1538.14)"
}, React.createElement("path", {
  d: "M0,0H87.546V87.546H0Z",
  fill: "none"
}), React.createElement("path", {
  className: "shape",
  d: "M31.182,4H9.3a7.286,7.286,0,0,0-7.259,7.3L2,55.068a7.317,7.317,0,0,0,7.3,7.3H67.659a7.317,7.317,0,0,0,7.3-7.3V18.591a7.317,7.317,0,0,0-7.3-7.3H38.477Z",
  transform: "translate(5.295 10.591)"
})), React.createElement("g", {
  transform: "translate(-846.227 1571.248)"
}, React.createElement("path", {
  d: "M0,0H31.957V31.957H0Z",
  fill: "none"
})), React.createElement("path", {
  fill: "#fff",
  d: "M33.554,7H27.243a2.1,2.1,0,0,0,0,4.207h6.311a6.311,6.311,0,0,1,0,12.622H27.243a2.1,2.1,0,0,0,0,4.207h6.311A10.518,10.518,0,0,0,33.554,7ZM14.622,17.518a2.11,2.11,0,0,0,2.1,2.1H29.347a2.1,2.1,0,0,0,0-4.207H16.725A2.11,2.11,0,0,0,14.622,17.518Zm4.207,6.311H12.518a6.311,6.311,0,0,1,0-12.622h6.311a2.1,2.1,0,0,0,0-4.207H12.518a10.518,10.518,0,0,0,0,21.036h6.311a2.1,2.1,0,0,0,0-4.207Z",
  transform: "translate(-868.86 1568.711)"
}));

var SvgInherited = function SvgInherited(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    className: "MuiSvgIcon-root svg-icon",
    width: 87.546,
    height: 87.546,
    viewBox: "0 0 87.546 87.546",
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgInherited, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/inherited.fd3c1e22.svg";
export { ForwardRef as ReactComponent };